export default function PatientActivityFeedIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#A27E8A" />
      <g clipPath="url(#clip0_5818_15993)">
        <path
          d="M14.0007 16.3333C16.578 16.3333 18.6673 14.244 18.6673 11.6667C18.6673 9.08934 16.578 7 14.0007 7C11.4233 7 9.33398 9.08934 9.33398 11.6667C9.33398 14.244 11.4233 16.3333 14.0007 16.3333Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 20.4163C8.4124 17.9758 10.9776 16.333 14 16.333C17.0224 16.333 19.5876 17.9758 21 20.4163"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5818_15993">
          <rect
            width="18.6667"
            height="18.6667"
            fill="white"
            transform="translate(4.66699 4.6665)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
